import React from "react";

export default function Footer() {
  return (
    <footer className="sub-layout text-sm text-right">
      Designed and built by Agnes
    </footer>
  );
}
